import { LocationStatus } from '~/Models/DTO/externalParties.model';

export const statusType = {
  [LocationStatus.Active]: 'success',
  [LocationStatus.Inactive]: 'danger',
  [LocationStatus.AwaitingApproval]: 'warning',
  [LocationStatus.Paused]: 'warning',
  [LocationStatus.Terminated]: 'danger',
};
